import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { ExperienceChatContext } from '#providers/experiences/experience-chat/ExperienceChat.context.ts';
import type { TExperienceChatContextValue } from '#providers/experiences/experience-chat/ExperienceChat.types.ts';

export const useExperienceChat = (): TExperienceChatContextValue =>
  useRequiredContext(
    ExperienceChatContext,
    'useExperienceChat is only available inside an ExperienceChatProvider',
  );
